import { render, staticRenderFns } from "./LeadText.vue?vue&type=template&id=e617a034&"
import script from "./LeadText.vue?vue&type=script&lang=js&"
export * from "./LeadText.vue?vue&type=script&lang=js&"
import style0 from "./LeadText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports